'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

const ERROR_MESSAGES: Record<string, string> = {
  OAuthSignin: 'ログインに失敗しました',
  OAuthCallback: 'ログインに失敗しました',
  Callback: '利用可能なユーザーが見つかりませんでした',
};

export const LoginErrorMessageHandler = () => {
  const searchParams = useSearchParams();
  const hasShownRef = useRef(false);

  useEffect(() => {
    const errorType = searchParams?.get('error');
    if (!errorType || hasShownRef.current) return;
    hasShownRef.current = true;
    alert(ERROR_MESSAGES[errorType] ?? 'エラーが発生しました');
  }, [searchParams]);

  return null;
};
